class CheckPopUpTutorials {
  static check(state) {
    if (!G.json.tutorials.POPUPTUTORIALS) return;
    if (!state) return;

    _.forEach(G.json.tutorials.POPUPTUTORIALS, (tutData, tutId) => {
      // console.log('tutId', tutId);

      const curLevel = G.saveState.getLastPassedLevelNr() + 1; // Levels starts counting at 0
      if (curLevel >= G.OMTsettings.FTUXSettings.disablePopUpTutorial) { // Past a certain level, pop up tutorials stop showing
        return; // This is for migrating COOK players
      }

      if (G.saveState.isPopUpTutorialPassed(tutId)) {
        // console.log('already seen');
        return;
      }

      // console.log(tutData);

      if (tutData.terms) {
        // console.log('!!!! checking terms');

        if (tutData.terms.disabled) {
          return;
        }

        if (tutData.terms.pastLevel) {
          if (curLevel < tutData.terms.pastLevel) {
            // console.log('Not ready to be seen yet');
            return;
          }
        }

        // IS ANY IN LAYER
        if (tutData.terms.isAnyInLayer) {
          // console.log('checking isAnyInLayer');
          if (game.state.current !== 'Game') {
            // console.log('failed isAnyInLayer - not game state');
            return;
          }

          if (!state.board.isAnyInBoard(tutData.terms.isAnyInLayer)) {
            // console.log("failed isAnyInLayer - not in board");
            return;
          }
        }
      }
      G.sb('pushWindow').dispatch(['popUpTutorial', tutId]);
    });
  }
}

// create global references
G.checkPopUpTutorials = CheckPopUpTutorials.check;
